import { clearSWRCache } from '../../utils/fetchWithSWR';

let inflight: Promise<any> | null = null;
let lastJson: any = null;
let lastAt = 0;
const TTL_MS = 60_000; // 60s dedupe
let lastFingerprint: string | null = null;
let bc: BroadcastChannel | null = null;

function getFingerprint(j: any): string {
  const authed = (j as any)?.authenticated ? '1' : '0';
  const sub = (j as any)?.user?.sub ?? (j as any)?.profile?.sub ?? (j as any)?.sub ?? '';
  return `${authed}:${String(sub)}`;
}

function postSessionUpdatedIfChanged(j: any): void {
  try {
    const fp = getFingerprint(j);
    if (lastFingerprint !== fp) {
      lastFingerprint = fp;
      // Local tab auth/session changed: clear SWR cache to prevent cross-user bleed.
      clearSWRCache();
      if (typeof window !== 'undefined' && 'BroadcastChannel' in window) {
        if (!bc) bc = new BroadcastChannel('experience-auth');
        bc.postMessage({
          type: 'session-updated',
          authenticated: !!(j as any)?.authenticated,
          userSub: (j as any)?.user?.sub ?? (j as any)?.sub ?? null,
          ts: Date.now(),
        } as any);
      }
    }
  } catch {}
}

export async function fetchSessionOnce(): Promise<any> {
  const now = Date.now();
  if (lastJson && now - lastAt < TTL_MS) return lastJson;
  if (inflight) return inflight;
  inflight = (async () => {
    try {
      const r = await fetch('/auth/session', { credentials: 'include', cache: 'no-store' });
      const j = await r.json().catch(() => ({}));
      lastJson = j;
      lastAt = Date.now();
      // broadcast to other tabs only when auth state actually changes
      postSessionUpdatedIfChanged(j);
      return j;
    } finally {
      inflight = null;
    }
  })();
  return inflight;
}

export function invalidateSessionCache(): void {
  lastAt = 0;
  lastJson = null;
}


